import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "../../../components/Common/DataTable";
import * as url from "../../../helpers/url_helper";
import $, { data } from "jquery";
import { useLocation, useNavigate } from "react-router-dom";
import Request from "../../../helpers/request";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from "axios";
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import useWindowDimensions from "../../../Utils/useWindowDimensions";
import SaveFilterPresetModal from "./SaveFilterPresetModal";
import SendNotificationModal from "./SendNotificationModal";
import AnalyticsUserTable, { analyticsColumns } from "./AnalyticsUserTable";
import SelectFilters, { FILTER_CONFIG } from "./SelectFilters";
import SaveFilterPresetList from "./SaveFilterPresetList";
import FilterStatisticsCards from "./FilterStatisticsCards";
import {
  PremisesListData,
  PremisesListResponse,
} from "../../../helpers/response/Admin/PremiseListResponse";
import getStorageData from "../../../Utils/getStorageData";
import {
  getFilterCount,
  getSelectedFilter,
  setActivityFilter,
  setDeviceFilter,
  setCityFilter,
} from "../../../store/slices/AnalyticsResponseSlice";

type ActivityFilterPayload = {
  filterType: string;
  minutes: number;
  minCount: number;
};

type DeviceFilterPayload = {
  filterType: string;
  filterCount: string;
  filterState: string;
};

type CityFilterPayload = {
  cityId: string[];
};

const Index = () => {
  let { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedList = useSelector(
    (state: any) => state.AnalyticsResponse.selectedFilter
  );
  // const {
  //   appOpenValue,
  //   appOperateValue,
  //   appNotOpenValue,
  //   appNotOperateValue,
  //   sceneCount,
  //   sceneRunCount,
  //   automationCount,
  //   automationRunCount,
  // } = useSelector((state: any) => state.AnalyticsResponse.filterCount);

  const [loading, setLoading] = useState(false);
  const [dataTableId, setDataTableId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [isOpenAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState<any>(selectedList);
  const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
  const appliedFiltersRef = useRef<string[]>([]);

  const [hasApplied, setHasApplied] = useState(false);
  const [recordsTotal, setRecordsTotal] = useState<number | null>(null);
  const [recordsFiltered, setRecordsFiltered] = useState<number | null>(null);

  const [rules, setRules] = useState([
    {
      category: "",
      option: "",
      number: "",
      minutes: "",
      minCount: "",
      activityType: "",
      deviceType: "",
      deviceCount: "",
      deviceState: "",
      cityIds: "",
      cityLabel: "",
    },
  ]);

  const [ruleErrors, setRuleErrors] = useState<
    {
      category?: string;
      option?: string;
      number?: string;
      minutes?: string;
      minCount?: string;
      activityType?: string;
      deviceType?: string;
      deviceCount?: string;
      deviceState?: string;
      cityIds?: string;
      cityLabel?: string;
    }[]
  >([]);
  const [isSaveModalOpen, setSaveModalOpen] = useState(false);
  const [savingPreset, setSavingPreset] = useState(false);
  const [selectedPresetId, setSelectedPresetId] = useState<string | null>(null);
  const [editingPresetId, setEditingPresetId] = useState<string | null>(null);
  const presetFormDefaults = {
    name: "",
    description: "",
    isActive: true,
    isForAll: true,
  };
  const [presetForm, setPresetForm] = useState({ ...presetFormDefaults });
  const [isNotifyModalOpen, setNotifyModalOpen] = useState(false);
  const [presetRefreshKey, setPresetRefreshKey] = useState(0);
  const controllerRef = useRef<AbortController | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const tableRef: any = useRef<HTMLTableElement>(null);
  const activityFilterRef = useRef<ActivityFilterPayload | null>(null);
  const deviceFilterRef = useRef<DeviceFilterPayload | null>(null);
  const cityFilterRef = useRef<CityFilterPayload | null>(null);
  const [cityOptions, setCityOptions] = useState<any[]>([]);

  const handleCloseSaveModal = () => {
    setSaveModalOpen(false);
    setEditingPresetId(null);
    // setPresetForm({ ...presetFormDefaults });
  };

  // Clear preset form whenever modal is closed (after save/update or manual close)
  // React.useEffect(() => {
  //   if (!isSaveModalOpen) {
  //     setPresetForm({ ...presetFormDefaults });
  //   }
  // }, [isSaveModalOpen]);

  const userType = getStorageData().userType;
  const token = localStorage.getItem("Authorization");

  // ---------------- BUILD RULES ----------------
  const buildFilters = (
    updatedRules: any
  ): {
    filters: string[];
    activityPayload: ActivityFilterPayload | null;
    devicePayload: DeviceFilterPayload | null;
    cityPayload: CityFilterPayload | null;
  } => {
    let finalFilters: string[] = [];
    let activityPayload: ActivityFilterPayload | null = null;
    let devicePayload: DeviceFilterPayload | null = null;
    let cityPayload: CityFilterPayload | null = null;

    updatedRules.forEach((rule: any) => {
      if (!rule.category || !rule.option) return;

      const categoryBlock = FILTER_CONFIG[rule.category];
      const optionItem = categoryBlock.options.find(
        (opt: any) => opt.value === rule.option || opt.prefix === rule.option
      );

      if (!optionItem) return;

      // Normal checkbox-based filter
      if (!optionItem.type) {
        finalFilters.push(optionItem.value);
      }

      // Numeric filter
      if (optionItem.type === "number") {
        if (rule.number && Number(rule.number) > 0) {
          finalFilters.push(`${optionItem.prefix}-${rule.number}`);
        }
      }

      // Activity filter: requires activityType, minutes, minCount
      if (optionItem.type === "activity") {
        if (
          rule.activityType &&
          rule.minutes &&
          Number(rule.minutes) > 0 &&
          rule.minCount &&
          Number(rule.minCount) > 0
        ) {
          activityPayload = {
            filterType: rule.activityType,
            minutes: Number(rule.minutes),
            minCount: Number(rule.minCount),
          };
        }
      }

      if (optionItem.type === "device") {
        if (rule.deviceType && rule.deviceCount && rule.deviceState) {
          devicePayload = {
            filterType: rule.deviceType,
            filterCount: rule.deviceCount,
            filterState: rule.deviceState,
          };
        }
      }

      if (optionItem.type === "city") {
        if (rule.cityIds) {
          const ids = rule.cityIds
            .split(",")
            .map((id: string) => id.trim())
            .filter(Boolean);
          if (ids.length) {
            cityPayload = { cityId: ids };
          }
        }
      }
    });

    return {
      filters: finalFilters,
      activityPayload,
      devicePayload,
      cityPayload,
    };
  };

  const fetchCityOptions = async (keyword: string, force = false) => {
    if (!force && (!keyword || keyword.length < 2)) {
      setCityOptions([]);
      return;
    }
    try {
      const res = await axios.get(
        `${url.BASE_URL}${url.GET_SEARCH_CITY_URL}?keyword=${encodeURIComponent(
          keyword
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const list = res.data?.data || res.data || [];
      const mapped =
        Array.isArray(list) && list.length
          ? list
              .map((item: any) => {
                const value = item.id || item._id || item.value;
                const label = item.name || item.label || item.value;
                if (!value) return null;
                return { value, label };
              })
              .filter(Boolean)
          : [];
      setCityOptions(mapped);
    } catch (err) {
      console.error("City search failed", err);
      setCityOptions([]);
    }
  };

  const handleSavePreset = async () => {
    if (!presetForm.name.trim()) {
      toast.error("Name is required to save preset");
      return;
    }
    const ok = handleApplyFilter();
    if (!ok) return;
    try {
      setSavingPreset(true);
      const payload = buildPresetPayload();

      if (editingPresetId) {
        // Update existing preset
        const reqBody = {
          filterId: editingPresetId,
          name: presetForm.name,
          moduleName: "user",
          filterPayload: payload.filterPayload,
          description: presetForm.description,
          isActive: presetForm.isActive,
          isForAll: presetForm.isForAll,
        };
        const response = await axios.post(
          `${url.BASE_URL}${url.UPDATE_FILTER_PRESETS}`,
          reqBody,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Filter updated");
        setSaveModalOpen(false);
        setPresetRefreshKey((prev) => prev + 1);
        setEditingPresetId(null);
        // Keep the same selectedPresetId since we're updating
      } else {
        // Create new preset
        const response = await axios.post(
          `${url.BASE_URL}${url.ADD_FILTER_PRESETS}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Filter saved");
        setSaveModalOpen(false);
        setPresetRefreshKey((prev) => prev + 1);
        // Set selectedPresetId to the newly created filter's _id
        const newFilterId = response?.data?.data?._id || null;
        setSelectedPresetId(newFilterId);
      }
    } catch (err: any) {
      console.error("Error saving filter", err);
      toast.error(
        editingPresetId ? "Failed to update filter" : "Failed to save filter"
      );
    } finally {
      setSavingPreset(false);
    }
  };

  const buildRulesFromFilter = (filterValue: string) => {
    const defaults = {
      category: "",
      option: "",
      number: "",
      minutes: "",
      minCount: "",
      activityType: "",
      deviceType: "",
      deviceCount: "",
      deviceState: "",
      cityIds: "",
      cityLabel: "",
    };
    if (!filterValue) return [];
    const parts = filterValue
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
    const rulesArr: any[] = [];
    parts.forEach((val) => {
      let matchedCategory: string | null = null;
      let matchedOption: string = val;
      let matchedNumber: string = "";

      // Check if value contains a dash (prefix-number format)
      if (val.includes("-")) {
        const [prefix, number] = val.split("-", 2);
        matchedOption = prefix;
        matchedNumber = number;
      }

      Object.entries(FILTER_CONFIG).forEach(([catKey, catVal]: any) => {
        if (matchedCategory) return;
        const hit = (catVal.options || []).find(
          (opt: any) => opt.value === matchedOption || opt.prefix === matchedOption
        );
        if (hit) {
          matchedCategory = catKey;
        }
      });
      if (matchedCategory) {
        rulesArr.push({ ...defaults, category: matchedCategory, option: matchedOption, number: matchedNumber });
      }
    });
    return rulesArr;
  };

  const handlePresetSelect = (preset: any) => {
    setSelectedPresetId(preset?._id || null);
    const payload = preset?.filterPayload || {};

    const rulesFromFilter = buildRulesFromFilter(payload.filter || "");
    const newRules: any[] = [...rulesFromFilter];

    if (payload.cityId && payload.cityId.length) {
      newRules.push({
        category: "onBoarded",
        option: "cityFilter",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: payload.cityId[0] || "",
        cityLabel: payload.city[0]?.name || "",
      });
    }

    if (payload.activityFilter) {
      newRules.push({
        category: "activity",
        option: "activityFilter",
        number: "",
        minutes: payload.activityFilter.minutes?.toString() || "",
        minCount: payload.activityFilter.minCount?.toString() || "",
        activityType: payload.activityFilter.filterType || "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: "",
        cityLabel: "",
      });
    }

    if (payload.deviceFilter) {
      newRules.push({
        category: "device",
        option: "deviceFilter",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: payload.deviceFilter.filterType || "",
        deviceCount: payload.deviceFilter.filterCount || "",
        deviceState: payload.deviceFilter.filterState || "",
        cityIds: "",
        cityLabel: "",
      });
    }

    if (!newRules.length) {
      newRules.push({
        category: "",
        option: "",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: "",
        cityLabel: "",
      });
    }

    setRules(newRules);
    setRuleErrors(newRules.map(() => ({})));
    setPresetForm({
      name: preset.name || "",
      description: preset.description || "",
      isActive: preset.isActive ?? true,
      isForAll: preset.isForAll ?? true,
    });

    appliedFiltersRef.current = (payload.filter || "")
      .split(",")
      .map((p: string) => p.trim())
      .filter(Boolean);
    setAppliedFilters(appliedFiltersRef.current);

    const activityPayload = payload.activityFilter || null;
    const devicePayload = payload.deviceFilter || null;
    const cityPayload =
      payload.cityId && payload.cityId.length
        ? { cityId: payload.cityId }
        : null;

    activityFilterRef.current = activityPayload;
    deviceFilterRef.current = devicePayload;
    cityFilterRef.current = cityPayload;

    dispatch(setActivityFilter(activityPayload));
    dispatch(setDeviceFilter(devicePayload));
    dispatch(setCityFilter(cityPayload));

    if (payload.search && typeof payload.search.value === "string") {
      setSearchValue(payload.search.value);
    }

    setHasApplied(false);
    destroyDataTable();
  };

  const handleSaveAndApplyClick = () => {
    const validated = validateFilters();
    if (validated) {
      setSaveModalOpen(true);
    }
  };
  const handleEditPreset = (preset: any) => {
    // Load preset data into form (same as selecting, which applies the filter)
    handlePresetSelect(preset);
    // Set editing state so button shows "Update" instead of "Save"
    setEditingPresetId(preset?._id || null);
  };

  const handleOpenNotify = () => {
    // const ok = handleApplyFilter();
    // if (ok) {
    setNotifyModalOpen(true);
    // }
  };

  const getCitySelectedOption = (value: string) => {
    if (!value) return null;
    const found = cityOptions.find((opt: any) => opt.value === value);
    const labelFallback =
      rules.find((r) => r.cityIds === value)?.cityLabel || value;
    return found || { value, label: labelFallback };
  };

  const getSelectValue = (options: any[], value: string) =>
    options.find((opt) => opt.value === value) || null;

  const buildPresetPayload = () => {
    const activityPayload = activityFilterRef.current;
    const devicePayload = deviceFilterRef.current;
    const cityPayload = cityFilterRef.current;
    return {
      name: presetForm.name,
      moduleName: "user",
      filterPayload: {
        draw: 1,
        order: [],
        start: 0,
        length: 100,
        search: {
          value: searchValue,
          regex: false,
        },
        filter: appliedFiltersRef.current?.join(",") || "",
        // filterType: selectFilter.value,
        cityId: cityPayload?.cityId || [],
        activityFilter: activityPayload || undefined,
        deviceFilter: devicePayload || undefined,
      },
      description: presetForm.description,
      isActive: presetForm.isActive,
      isForAll: presetForm.isForAll,
    };
  };

  // preset list refresh handled in SaveFilterPresetList component

  const updateCategory = (index: any, category: any) => {
    const updated = [...rules];
    updated[index] = {
      category,
      option:
        category === "activity"
          ? "activityFilter"
          : category === "device"
          ? "deviceFilter"
          : category === "city"
          ? "cityFilter"
          : "",
      number: "",
      minutes: "",
      minCount: "",
      activityType: "",
      deviceType: "",
      deviceCount: "",
      deviceState: "",
      cityIds: "",
      cityLabel: "",
    };
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateOption = (index: any, option: any) => {
    const updated = [...rules];
    updated[index].option = option;
    updated[index].number = "";
    updated[index].minutes = "";
    updated[index].minCount = "";
    updated[index].activityType = "";
    updated[index].deviceType = "";
    updated[index].deviceCount = "";
    updated[index].deviceState = "";
    updated[index].cityIds = "";
    updated[index].cityLabel = "";
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateNumber = (index: any, number: any) => {
    const updated = [...rules];
    updated[index].number = number;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateActivityType = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].activityType = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateMinutes = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].minutes = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateMinCount = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].minCount = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateDeviceType = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].deviceType = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateDeviceCount = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].deviceCount = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateDeviceState = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].deviceState = value;
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const updateCityIds = (index: any, value: string) => {
    const updated = [...rules];
    updated[index].cityIds = value;
    updated[index].cityLabel =
      cityOptions.find((o: any) => o.value === value)?.label || "";
    setRules(updated);
    setRuleErrors((prev) => {
      const next = [...prev];
      next[index] = {};
      return next;
    });
  };

  const addRule = () => {
    setRules([
      ...rules,
      {
        category: "",
        option: "",
        number: "",
        minutes: "",
        minCount: "",
        activityType: "",
        deviceType: "",
        deviceCount: "",
        deviceState: "",
        cityIds: "",
        cityLabel: "",
      },
    ]);
    setRuleErrors([...ruleErrors, {}]);
  };

  const removeRule = (index: any) => {
    const updatedRules = rules.filter((_, i) => i !== index);
    const updatedErrors = ruleErrors.filter((_, i) => i !== index);
    setRules(updatedRules);
    setRuleErrors(updatedErrors);
  };

  const resetCounts = () => {
    dispatch(
      getFilterCount({
        appOpenValue: "1",
        appOperateValue: "1",
        appNotOpenValue: "1",
        appNotOperateValue: "1",
        sceneCount: "1",
        sceneRunCount: "1",
        automationCount: "1",
        automationRunCount: "1",
      })
    );
  };

  useEffect(() => {
    dispatch(getSelectedFilter([]));
    dispatch(setActivityFilter(null));
    dispatch(setDeviceFilter(null));
    dispatch(setCityFilter(null));
    resetCounts();
    appliedFiltersRef.current = [];
    activityFilterRef.current = null;
    deviceFilterRef.current = null;
    cityFilterRef.current = null;
    setCityOptions([]);
  }, []);

  const handleAdvancedFilterNew = (name?: any, value?: string) => {
    if (!value) return;

    let updatedList = [...selectedList];

    // 1️⃣ Toggle remove if already selected
    if (updatedList.includes(value)) {
      updatedList = updatedList.filter((v) => v !== value);
    } else {
      // 2️⃣ Remove previous values from the same category
      updatedList = updatedList.filter((v) => !v.startsWith(name));

      updatedList.push(value);
    }

    dispatch(getSelectedFilter(updatedList));
  };

  const reloadDataTable = () => {
    if (dataTableId && tableRef.current) {
      try {
        const dataTableInstance: any = $(`#${dataTableId}`).DataTable();
        if (dataTableInstance) {
          dataTableInstance.ajax.reload(null, false);
        }
      } catch (error) {
        console.error("Error reloading DataTable:", error);
        // If reload fails, reinitialize
        initializeData();
      }
    }
  };

  const handleDataTableIdChange = (dataTableId: any) => {
    setDataTableId(dataTableId);
  };

  // <button class="column-click" style="border: none; outline: none; background: none;"><span class="badge bg-primary" style="height: 25px; width: 60px; font-size: 12px; padding: 6px;">Detail</span></button>

  const toggleAdvanceFilter = () => {
    setOpenAdvancedFilter(!isOpenAdvancedFilter);
  };

  const handleAdvancedFilter = (name?: any, value?: string) => {
    // var list = [];
    var selectedList1 = [];

    if (selectedList.includes(value)) {
      const filterData = selectedList.filter((e: string) => e != value);
      dispatch(getSelectedFilter(filterData));
      // setAdvancedFilter(filterData)
    } else if (
      selectedList.some((item: any) =>
        item?.includes(name?.target?.name ? name?.target?.name : name)
      )
    ) {
      const filterData = selectedList.filter(
        (e: string) =>
          !e.includes(name?.target?.name ? name?.target?.name : name)
      );
      filterData.push(value);
      dispatch(getSelectedFilter(filterData));
    } else {
      selectedList1.push(...advancedFilter, value);
      dispatch(getSelectedFilter([...selectedList, value]));
      // setAdvancedFilter([...advancedFilter, value])
    }
    // console.log("selectedList", selectedList1);
  };

  const resetAdvanceFilterCount = () => {
    dispatch(
      getFilterCount({
        appOpenValue: "1",
        appOperateValue: "1",
        appNotOpenValue: "1",
        appNotOperateValue: "1",
        sceneCount: "1",
        sceneRunCount: "1",
        automationCount: "1",
        automationRunCount: "1",
      })
    );
  };

  useEffect(() => {
    if (!state?.isReload) {
      dispatch(getSelectedFilter([]));
      dispatch(setActivityFilter(null));
      dispatch(setDeviceFilter(null));
      dispatch(setCityFilter(null));
      activityFilterRef.current = null;
      deviceFilterRef.current = null;
      cityFilterRef.current = null;
      setCityOptions([]);
      resetAdvanceFilterCount();
    }
  }, []);

  const handleAdvancedFilterCount = (name: string, e: any) => {
    if (Number(e.target.value) < 0) {
      dispatch(getFilterCount({ [e.target.name]: "1" }));
    } else if (Number(e.target.value) <= 999) {
      dispatch(getFilterCount({ [e.target.name]: e.target.value }));
    }
    if (selectedList.some((item: string) => item.includes(name))) {
      handleAdvancedFilter(name, `${name}-${e.target.value}`);
    }
  };

  // Check if there's at least one valid rule
  const hasValidRules = () => {
    return rules.some((rule) => {
      if (!rule.category || !rule.option) return false;

      const categoryBlock = FILTER_CONFIG[rule.category];
      if (!categoryBlock) return false;

      const optionItem = categoryBlock.options.find(
        (opt: any) => opt.value === rule.option || opt.prefix === rule.option
      );

      if (!optionItem) return false;

      // For number type filters, number must be filled and > 0
      if (optionItem.type === "number") {
        return rule.number && Number(rule.number) > 0;
      }

      if (optionItem.type === "activity") {
        return (
          rule.activityType &&
          rule.minutes &&
          Number(rule.minutes) > 0 &&
          rule.minCount &&
          Number(rule.minCount) > 0
        );
      }

      if (optionItem.type === "device") {
        return rule.deviceType && rule.deviceCount && rule.deviceState;
      }

      if (optionItem.type === "city") {
        return rule.cityIds && rule.cityIds.trim().length > 0;
      }

      // For non-number filters, category and option are enough
      return true;
    });
  };

  const validateFilters = () => {
    // Normalize implicit options for activity/device
    const normalizedRules = rules.map((rule) => {
      if (rule.category === "activity" && !rule.option) {
        return { ...rule, option: "activityFilter" };
      }
      if (rule.category === "device" && !rule.option) {
        return { ...rule, option: "deviceFilter" };
      }
      return rule;
    });

    setRules(normalizedRules);

    const { filters, activityPayload, devicePayload, cityPayload } =
      buildFilters(normalizedRules);

    // Build per-rule errors
    const currentErrors = normalizedRules.map((rule) => {
      const err: {
        category?: string;
        option?: string;
        number?: string;
        minutes?: string;
        minCount?: string;
        activityType?: string;
        deviceType?: string;
        deviceCount?: string;
        deviceState?: string;
        cityIds?: string;
      } = {};
      if (!rule.category) {
        err.category = "Category is required";
      }

      const categoryBlock = FILTER_CONFIG[rule.category];
      const optionItem = categoryBlock?.options.find(
        (opt: any) => opt.value === rule.option || opt.prefix === rule.option
      );

      if (rule.category && !rule.option) {
        err.option = "Condition is required";
      }

      if (
        optionItem?.type === "number" &&
        (!rule.number || Number(rule.number) <= 0)
      ) {
        err.number = "Enter a value greater than 0";
      }

      if (optionItem?.type === "activity") {
        if (!rule.activityType) {
          err.activityType = "Select activity type";
        }
        if (!rule.minutes || Number(rule.minutes) <= 0) {
          err.minutes = "Minutes must be greater than 0";
        }
        if (!rule.minCount || Number(rule.minCount) <= 0) {
          err.minCount = "Min count must be greater than 0";
        }
      }

      if (optionItem?.type === "device") {
        if (!rule.deviceType) {
          err.deviceType = "Select device type";
        }
        if (!rule.deviceCount) {
          err.deviceCount = "Enter count or range";
        }
        if (!rule.deviceState) {
          err.deviceState = "Select device state";
        }
      }

      if (optionItem?.type === "city") {
        if (!rule.cityIds || !rule.cityIds.trim()) {
          err.cityIds = "Enter one or more city ids";
        }
      }

      return err;
    });

    setRuleErrors(currentErrors);
    setRules(normalizedRules);

    const hasRuleErrors = currentErrors.some(
      (e) =>
        e.category ||
        e.option ||
        e.number ||
        e.minutes ||
        e.minCount ||
        e.activityType ||
        e.deviceType ||
        e.deviceCount ||
        e.deviceState ||
        e.cityIds
    );

    if (hasRuleErrors) {
      toast.error("Please fix validation errors before applying");
      return null;
    }

    if (!filters.length && !activityPayload && !devicePayload && !cityPayload) {
      toast.error("Please add at least one valid filter before applying");
      return null;
    }

    // persist normalized rules for UI
    setRules(normalizedRules);
    return { filters, activityPayload, devicePayload, cityPayload };
  };

  const handleApplyFilter = () => {
    const validated = validateFilters();
    if (!validated) {
      setHasApplied(false);
      destroyDataTable();
      return false;
    }
    const { filters, activityPayload, devicePayload, cityPayload } = validated;

    appliedFiltersRef.current = filters;
    activityFilterRef.current = activityPayload;
    deviceFilterRef.current = devicePayload;
    cityFilterRef.current = cityPayload;
    setAppliedFilters(filters);
    dispatch(getSelectedFilter(filters));
    dispatch(setActivityFilter(activityPayload));
    dispatch(setDeviceFilter(devicePayload));
    dispatch(setCityFilter(cityPayload));
    setHasApplied(true);
    setTimeout(() => {
      if (tableRef.current) {
        initializeData();
        const dataTableId = $(tableRef.current).attr("id");
        if (dataTableId) {
          handleDataTableIdChange(dataTableId);
        }
      }
    }, 100);
    return true;
  };

  // AnalyticsTable merged functions
  const fetchData = (dataTablesData: any, callback: any) => {
    $("#customLoader").show();

    // Cancel previous request
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;
    const activityPayload = activityFilterRef.current;
    const devicePayload = deviceFilterRef.current;
    const cityPayload = cityFilterRef.current;

    const reqObj: any = {
      ...dataTablesData, // include paging/sorting info for server-side pagination
      filter: appliedFiltersRef.current?.join(",") || "",
      // filterType: selectFilter.value,
      search: {
        value: searchValue,
        regex: false,
      },
    };
    if (activityPayload) {
      reqObj.activityFilter = activityPayload;
    }
    if (devicePayload) {
      reqObj.deviceFilter = devicePayload;
    }
    if (cityPayload?.cityId?.length) {
      reqObj.cityId = cityPayload.cityId;
    }
    axios
      .post(`${url.BASE_URL}${url.GET_USERS_DETAIL_URL}`, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      })
      .then((response) => {
        const res: PremisesListResponse = response.data;
        $("#customLoader").hide();
        setRecordsTotal(res.recordsTotal ?? null);
        setRecordsFiltered(res.recordsFiltered ?? null);
        callback({
          draw: dataTablesData.draw,
          recordsTotal: res.recordsTotal,
          recordsFiltered: res.recordsFiltered,
          data: res.data,
        });
        // setTableData(res.data);
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          // Request was cancelled, ignore
          return;
        }
        if (err.response && err.response.status === 401) {
          localStorage.clear();
          window.location.reload();
        } else {
          console.error("Error fetching data:", err);
          $("#customLoader").hide();
          setRecordsTotal(null);
          setRecordsFiltered(null);
        }
      });
  };

  const destroyDataTable = () => {
    if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
      $(tableRef.current).empty();
    }
  };

  const initializeData = () => {
    try {
      if (!tableRef.current) {
        return;
      }
      destroyDataTable();

      const dataTableInstance = $(tableRef.current).DataTable({
        processing: false,
        serverSide: true,
        ajax: fetchData,
        columns: analyticsColumns,
        searching: true,
        ordering: false,
        paging: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
      });
      $(tableRef.current)
        .closest(".dataTables_wrapper")
        .find(".dataTables_filter")
        .hide();
      $(tableRef.current).on("click", ".column-click", function (e) {
        const data = dataTableInstance.row($(this).closest("tr")).data();
        // handleColumnClicked can be added if needed
      });

      $(tableRef.current).closest(".dt-container").find(".dt-length").hide();
      $(tableRef.current).closest(".dt-container").find(".dt-search").hide();

      $("#customSearchInput").on("input", function () {
        const searchValue: any = $(this).val();
        $(tableRef.current).DataTable().search(searchValue).draw();
      });

      $("#customFilterInput").on("change", function () {
        const selectedValue = $(this).val();
        dataTableInstance.draw();
      });

      $(tableRef.current).off("click", ".delete-btn");
      setTimeout(() => {
        $(tableRef.current).on("click", ".delete-btn", function () {
          const rowData = dataTableInstance.row($(this).parents("tr")).data();
          if (rowData) {
            // handleDeleteClick can be added if needed
          } else {
            console.warn("Row data is undefined.");
          }
        });
      }, 500);

      $(tableRef.current).on("preXhr.dt", function () {
        $("#customLoader").show();
        setLoading(true);
      });

      $(tableRef.current).on("xhr.dt", function () {
        $("#customLoader").hide();
        setLoading(false);
      });
      $(tableRef.current)
        .off("error.dt")
        .on("error.dt", function () {
          $("#customLoader").hide();
          setLoading(false);
        });

      $(tableRef.current).find("thead th").css("background-color", "#EFF2F7");

      const dataTableId = $(tableRef.current).attr("id");
      if (dataTableId) {
        handleDataTableIdChange(dataTableId);
      }
    } catch (error) {
      console.error("Error initializing DataTable:", error);
    }
  };

  useEffect(() => {
    if (!hasApplied || !tableRef.current) return;
    initializeData();
  }, [appliedFilters, searchValue, hasApplied]);

  return (
    <React.Fragment>
      <div>
        <ToastContainer />
        <Row>
          <Col>
            <Card
              //   className="shadow"
              style={{
                marginTop: 100,
                marginLeft: 30,
                marginRight: 30,
                marginBottom: 0,
              }}
            >
              <CardBody>
                <Row>
                  <Col
                    // md={10}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "12px",
                          gap: 12,
                        }}
                      >
                        <h5 className="m-0">Advanced Filter</h5>

                        <div
                          className="d-flex"
                          style={{
                            gap: 8,
                            justifyContent: "center",
                            alignItems: "anchor-center",
                          }}
                        >
                          <SaveFilterPresetList
                            token={token}
                            refreshKey={presetRefreshKey}
                            onSelect={(preset) => handlePresetSelect(preset)}
                            selectedPresetId={selectedPresetId}
                            onEdit={(preset) => handleEditPreset(preset)}
                          />

                          <Button
                            color="danger"
                            size="sm"
                            disabled={loading}
                            onClick={() => {
                              const clearedFilters: any = [];
                              appliedFiltersRef.current = clearedFilters;
                              activityFilterRef.current = null;
                              deviceFilterRef.current = null;
                              cityFilterRef.current = null;
                              setCityOptions([]);
                              setAppliedFilters(clearedFilters);
                              dispatch(getSelectedFilter(clearedFilters));
                              dispatch(setActivityFilter(null));
                              dispatch(setDeviceFilter(null));
                              dispatch(setCityFilter(null));
                              resetAdvanceFilterCount();
                              setRules([
                                {
                                  category: "",
                                  option: "",
                                  number: "",
                                  minutes: "",
                                  minCount: "",
                                  activityType: "",
                                  deviceType: "",
                                  deviceCount: "",
                                  deviceState: "",
                                  cityIds: "",
                                  cityLabel: "",
                                },
                              ]);
                              setRuleErrors([{}]);
                              setHasApplied(false);
                              setRecordsTotal(null);
                              setRecordsFiltered(null);
                              destroyDataTable();
                              setDataTableId(null);
                              setSelectedPresetId(null);
                              setEditingPresetId(null);
                              $("#customLoader").hide();
                              setPresetForm({ ...presetFormDefaults });
                            }}
                          >
                            Clear All
                          </Button>
                        </div>
                      </div>

                      <Row>
                        <Col md={10}>
                          <SelectFilters
                            rules={rules}
                            ruleErrors={ruleErrors}
                            filterConfig={FILTER_CONFIG}
                            cityOptions={cityOptions}
                            getSelectValue={getSelectValue}
                            getCitySelectedOption={getCitySelectedOption}
                            fetchCityOptions={fetchCityOptions}
                            updateCategory={updateCategory}
                            updateOption={updateOption}
                            updateNumber={updateNumber}
                            updateMinutes={updateMinutes}
                            updateMinCount={updateMinCount}
                            updateActivityType={updateActivityType}
                            updateDeviceType={updateDeviceType}
                            updateDeviceCount={updateDeviceCount}
                            updateDeviceState={updateDeviceState}
                            updateCityIds={updateCityIds}
                            removeRule={removeRule}
                            addRule={addRule}
                          />
                        </Col>
                        <Col md={2} className="d-flex flex-column gap-2">
                          <FilterStatisticsCards
                            hasApplied={hasApplied}
                            loading={loading}
                            recordsTotal={recordsTotal}
                            recordsFiltered={recordsFiltered}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div
                      className="d-flex justify-content-end mt-3"
                      style={{ gap: 8 }}
                    >
                      {hasApplied && (
                        <Button
                          color="success"
                          size="sm"
                          disabled={loading}
                          onClick={handleOpenNotify}
                        >
                          Send Notification
                        </Button>
                      )}
                      {/* {editingPresetId ? (
                        <Button
                          // color="success"
                          className="btn btn-dark"
                          size="sm"
                          disabled={loading}
                          onClick={handleSaveAndApplyClick}
                        >
                          Update
                        </Button>
                      ) : (
                        <Button
                          // color="success"
                          className="btn btn-dark"
                          size="sm"
                          disabled={loading}
                          onClick={handleSaveAndApplyClick}
                        >
                          Save
                        </Button>
                      )} */}
                      {editingPresetId && (
                        <Button
                          // color="success"
                          className="btn btn-dark"
                          size="sm"
                          disabled={loading}
                          onClick={handleSaveAndApplyClick}
                        >
                          Update
                        </Button>
                      )}
                      {!selectedPresetId && (
                        <Button
                          // color="success"
                          className="btn btn-dark"
                          size="sm"
                          disabled={loading}
                          onClick={handleSaveAndApplyClick}
                        >
                          Save
                        </Button>
                      )}
                      <Button
                        // color="primary"
                        className="btn btn-dark"
                        size="sm"
                        disabled={loading}
                        onClick={handleApplyFilter}
                      >
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        Apply
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <AnalyticsUserTable
          hasApplied={hasApplied}
          loading={loading}
          tableRef={tableRef}
        />
      </div>

      <SaveFilterPresetModal
        isOpen={isSaveModalOpen}
        toggle={handleCloseSaveModal}
        presetForm={presetForm}
        setPresetForm={setPresetForm}
        savingPreset={savingPreset}
        onSave={handleSavePreset}
        title={editingPresetId ? "Update Filter Preset" : "Save Filter Preset"}
        confirmLabel={editingPresetId ? "Update" : "Save"}
      />

      <SendNotificationModal
        isOpen={isNotifyModalOpen}
        toggle={() => setNotifyModalOpen(false)}
        activityPayload={activityFilterRef.current}
        devicePayload={deviceFilterRef.current}
        cityPayload={cityFilterRef.current}
        appliedFilters={appliedFiltersRef.current || []}
        searchValue={searchValue}
      />
    </React.Fragment>
  );
};

export default Index;
